export default __webpack_public_path__ + "static/media/aboutprofile.00e3b86e.jpg";